import {AdditivesForClinkerClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

const fields = [{key: AdditivesForClinkerClassificationInputNames.Category}]

export const AdditivesForClinkerClassificationHeader = () => {
  return (
    <ClassificationHeaderCells fields={fields} materialType={MaterialType.AdditivesForClinker} />
  )
}
